<template>
  
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Histórico Fiscal de <strong>{{data_inicio_cabecalho}}</strong> à <strong>{{data_fim_cabecalho}}</strong></h4>
          </div>

            <a @click="getLastMonth" class="btn btn-info mx-auto-mobile mb-2-mobile btn-primary" style="color:white;">Mês Passado</a>
            <a @click="getCurrentMonth" class="btn btn-info mx-auto-mobile mb-2-mobile btn-primary" style="color:white;">Mês Atual</a>

          <div class="row">
            
            
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="data_fim">
            
            <select  class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="modelo">
              <option value="55">Modelo: 55</option>
              <option value="59">Modelo: 59</option>
            </select>
            <select class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="status">
              <option value="null">Todos os status</option>
              <option value="AUTORIZADA">Status: Autorizada</option>
              <option value="CANCELADA">Status: Cancelada/Inut.</option>
            </select>
            
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile" v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>

          <div class="alert alert-danger" role="alert" v-show="data_sinc < data_fim || data_sinc < data_inicio">Atenção! O período selecionado pode estar incompleto devido a falta de sincronização da loja com o sistema de backup, a ultima sincronização foi feita em {{data_sinc | moment("DD/MM/YYYY")}}</div>
          <div class="mb-3">
            <div class="row">

             <a target="_blank" class="btn btn-round btn-wd btn-info hidden-mobile" :href="notas_url">Download todas</a>            
             <a :href="notasHref" target="_blank" class="btn btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile btn-primary">Exportar PDF</a>
             <a @click="showEmail" class="btn btn btn-round btn-wd btn-success mx-auto-mobile mb-2-mobile btn-primary" style="background-color:#8a05be;" >Enviar para Contador</a>
           
              <input type="email" class="form-control mx-2 mx-auto-mobile my-2-mobile" v-model="email" v-if="showemail" style="max-width: 220px; margin-top: 15px;">
              <a @click="notasEmail" class="btn mx-2 btn-success" v-if="showemail" style="background-color:#8a05be;" ><i class="fa fa-send"></i></a>
            </div>

            <div v-for="nota of notas" class="row py-3 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong v-if="modelo == '59'">{{ nota.pedido_object.cliente_object.nome_razao }}</strong>
                <strong v-if="modelo == '55'">{{ nota.natOp_B04 }}</strong>
                <br>
                <strong>Pedido {{ nota.pedido }}</strong>
                <br>
                <span style="color: #888; font-size: 10px;">{{ nota.dhEmi | moment("DD/MM/YYYY HH:mm") }} {{ nota.hEmi }}</span>
              </div>
              <div class="col-6">
                Nota {{ nota.nCFe }}
                <br>
                St. {{ nota.cStat }}
                <br>
                {{ nota.vCFe | currencyBrl(true) }}
                <a target="_blank" :href="notas_url" class="btn btn-sm btn-info px-2 py-1" style="font-size: 10px; position: absolute; right: 5px; top: -10px"><i class="fa fa-download"></i></a>
                <a target="_blank" :href="nota.sefaz_link" class="btn btn-sm btn-info px-2 py-1" style="font-size: 10px; position: absolute; right: 5px; top: 25px"><i class="fa fa-search"></i></a>

              </div>
            </div>
          </div>


          <div class="row">
                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="material-card" style="">
                    <!-- <div class="card-label-aut">
                        <strong><a>AUTORIZADAS</a></strong>
                    </div> -->
                    <div class="card-content">
                      <a>
                      <i class="fa fa-fw fa-check check-color"></i>
                      </a>
                      <h4>
                        <strong>
                          <animated-number v-if="resumo.numero_aut !== undefined" :value="resumo.numero_aut"></animated-number>
                          <i v-else class="fa fa-circle-o-notch fa-spin"></i>
                        </strong>
                      </h4>
                      <strong><a>NOTAS AUTORIZADAS</a></strong>
                    </div>

                    <div class="mc-content">
                      <div class="">
                      </div>
                    </div>
                    <div class="mc-footer">
                      <strong>TOTAL: R$ </strong>
                      <strong><animated-number v-if="resumo.valor_aut !== undefined" :value="resumo.valor_aut"></animated-number></strong>

                    </div>
                  </div>
                </div>

                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="material-card" style="">
                    <!-- <div class="card-label-canc">
                        <strong><a>CANCELADAS</a></strong>
                    </div> -->
                    <div class="card-content">
                      <a>
                      <i class="fa fa-fw fa-times times-color"></i>
                      </a>
                      <h4>
                        <strong>
                          <animated-number v-if="resumo.numero_can !== undefined" :value="resumo.numero_can"></animated-number>
                          <i v-else class="fa fa-circle-o-notch fa-spin"></i>
                        </strong>
                      </h4>
                      <strong><a>NOTAS CANCELADAS</a></strong>
                    </div>

                    <div class="mc-content">
                      <div class="">
                      </div>
                    </div>
                    <div class="mc-footer-canc">
                      <strong>TOTAL: R$ </strong> 
                      <strong><animated-number v-if="resumo.valor_can !== undefined" :value="resumo.valor_can"></animated-number></strong>
                        
                    </div>
                  </div>
                </div>

                <!--<div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="material-card" style="">
                    <!-- <div class="card-label-ban">
                        <strong><a>INUTILIZADAS</a></strong>
                    </div> -->
                    <!--<div class="card-content">
                      <a>
                      <i class="fa fa-fw fa-ban ban-color"></i>
                      </a>
                      <h4>
                        <strong>
                          <animated-number v-if="resumo.numero_inut !== undefined" :value="resumo.numero_inut"></animated-number>
                          <i v-else class="fa fa-circle-o-notch fa-spin"></i>
                        </strong>
                      </h4>
                      <strong><a>NOTAS INUTILIZADAS</a></strong>
                    </div>

                    <div class="mc-content">
                      <div class="">
                      </div>
                    </div>
                    <div class="mc-footer-ban">
                      <strong>TOTAL: R$ </strong>
                      <strong><animated-number v-if="resumo.valor_inut !== undefined" :value="resumo.valor_inut"></animated-number></strong>

                    </div>
                  </div>
                </div>-->

                <div class="col-md-3 col-sm-6 col-xs-12">
                  <div class="material-card" style="">
                    <!-- <div class="card-label-clock">
                        <strong><a>PENDENTES</a></strong>
                    </div> -->
                    <div class="card-content">
                      <a>
                      <i class="fa fa-fw fa-clock-o clock-color"></i>
                      </a>
                      <h4>
                        <strong>
                          <animated-number v-if="resumo.numero_pend !== undefined" :value="resumo.numero_pend"></animated-number>
                          <i v-else class="fa fa-circle-o-notch fa-spin"></i>
                        </strong>
                      </h4>
                      <strong><a>NOTAS PENDENTES</a></strong>
                    </div>

                    <div class="mc-content">
                      <div class="">
                      </div>
                    </div>
                    <div class="mc-footer-clock">
                      <strong>TOTAL: R$ </strong>
                      <strong><animated-number v-if="resumo.valor_pend !== undefined" :value="resumo.valor_pend"></animated-number></strong>

                    </div>
                  </div>
                </div>

            </div>


          <table class="display responsive nowrap table table-hover table-striped table-bordered hidden-mobile">
            <thead>
              <tr>
                <th>N. Pedido</th>
                <th class="">D. Emissão</th>
                <th class="text-right">Status</th>
                <th class="text-center">Modelo</th>
                <th class="text-center">Série do SAT</th>
                <th class="text-center">N. Nota</th>
                <th class="text-center">Valor</th>
                <th class="text-center" v-if="modelo == '59'">Destinatário</th>
                <th class="text-center" v-if="modelo == '55'">Natureza</th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="nota of notas">
                <td class="">{{ nota.pedido }}</td>
                <td class="">{{ nota.dEmi | moment("DD/MM/YYYY") }} {{nota.hEmi | moment("HH:mm")}}</td>
                <td class="text-center">{{ nota.cStat }}</td>
                <td class="text-center">{{ nota.mod }}</td>
                <td class="text-center">{{ nota.nserieSAT }}</td>
                <td class="text-center">{{ nota.nCFe }}</td>
                <td class="text-center">{{ nota.vCFe | currencyBrl(true) }}</td>
                <td class="text-center" v-if="modelo == '59'">{{ nota.pedido_object.cliente_object.nome_razao }}</td>
                <td class="text-center" v-if="modelo == '55'">{{ nota.natOp_B04 }}</td>
                <td class="text-center">
                  <button @click="download(nota.codigo)" v-if="modelo == 59" type="button" class="btn btn-sm btn-primary px-2 py-1" title="Importar"><i class="fa fa-download"></i></button>
                  <a target="_blank" :href="nota.link" v-if="modelo == 55" class="btn btn-primary btn-sm" style="padding-left: 10px; padding-right: 10px"><i class="fa fa-download" style="font-size: 12px"></i></a>
                  <a target="_blank" :href="nota.sefaz_link" v-if="modelo == 55" class="btn btn-primary btn-sm" style="padding-left: 10px; margin-left: 5px; padding-right: 10px"><i class="fa fa-search" style="font-size: 12px"></i></a>
                </td>
              </tr>
              <tr v-if="!notas || !notas.length">
                <td class="text-center" colspan="9">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
          </table>


          <div class="row">
            <div class="col-12 col-md-6 text-center-mobile">
              Mostrando de {{ from }} até {{ to }} de {{ total}} registros
            </div>
            <div class="col-12 col-md-6 text-right text-center-mobile mt-2-mobile">
              <paginate
                :pageCount="pageCount"
                :clickHandler="changePage"
                :prevText="'Ante.'"
                :nextText="'Próx.'"
                :containerClass="'pagination'">
              </paginate>
            </div>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>

<!-- 
  N. Pedido
  Dt. Emissão
  Status
  Protocolo
  Modelo
  Série
  N. Nota -->

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
    Progress as NProgress,
    LineChart
  } from 'src/components'
import { setInterval } from 'timers';
import {Table, TableColumn} from 'element-ui'
import HeaderChart from '@/pages/Dashboard/Dashboard/HeaderChart'
import moment from 'moment'
import GlobalFunctions from '@/globalFunctions.js'
import FiscalService from '@/services/FiscalService.js'

import VendaService from '@/services/VendaService.js'
export default {
    components: {
      Card,
      AnimatedNumber,
      LineChart,
      NProgress,
      HeaderChart,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment
    },
    data() {
      return {
        notasHref: '',
        data_inicio: moment().startOf('month').format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().startOf('month').format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        data_sinc: null,
        token: null,
        notas: [],
        modelo:59,
        notas_url: '',
        status: 'null',
        email:'',


        from: 0,
        to: 0,
        total: 0,
      

        current_page: 1,
        pageCount: 0,
        resumo: [],
        showemail: false,
      }
    },
    methods:{
      changePage(page) {
        this.current_page = page
        this.loadNotas()
      },
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadNotas()
        this.loadSum()
      },
      showEmail(){
        if(this.showemail){
          this.showemail = false;
        }else{
          this.showemail = true;
        }
      },
      getLinkWithToken(link) {
        return link + "?token=" + this.token
      },
      notasEmail(){
         let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}&status=${this.status}&modelo=${this.modelo}&email=${this.email}`
         let loader = this.$loading.show()

        FiscalService.mailCfe(params).then(res => {
          this.$swal('Email enviado com sucesso!','', 'success')
          loader.hide()
        }).catch(err => {
          loader.hide()
        })

      },
      loadNotas() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}&status=${this.status}&modelo=${this.modelo}`


        
        let loader = this.$loading.show()

        FiscalService.loadCfe(params).then(res => {
          this.notas = res.data.data
          console.log(this.notas);
          this.pageCount = res.data.last_page
          this.notas_url = process.env.VUE_APP_API_URL+'cfe/xml/download' + params + "&token=" + this.token

          this.from = res.data.from
          this.to = res.data.to
          this.total = res.data.total;
          let stores = JSON.parse(localStorage.getItem('stores'));
          let instalacao = stores.find(store => store.idi == JSON.parse(localStorage.getItem('current_store')).idi);
          this.data_sinc = moment(instalacao.ultima_conexao_ws).format('YYYY-MM-DD');
          loader.hide()
        }).catch(err => {
          loader.hide()
        })

        this.reloadNotasHref()
      },
      loadSum(){
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}`

        FiscalService.sumCfe(params).then(res => {
          this.resumo = res.data
          
        }).catch(err => {
          console.log(err);
          
        })
      },
      download(codigo) {
        FiscalService.download(codigo,localStorage.getItem('current_idi')).then(resp => {
          var xmltext = resp.data;

          var filename = codigo+".xml";
          var pom = document.createElement('a');
          var bb = new Blob([xmltext], {type: 'application/octet-stream'});

          pom.setAttribute('href', window.URL.createObjectURL(bb));
          pom.setAttribute('download', filename);

          pom.dataset.downloadurl = ['application/octet-stream', pom.download, pom.href].join(':');
          pom.draggable = true; 
          pom.classList.add('dragout');

          pom.click();
        })
        
        
      },
      reloadNotasHref(){
        let stores = JSON.parse(localStorage.getItem('stores'));
        let loja = stores.find(element => element.idi == localStorage.getItem('current_idi'));
        let url = process.env.VUE_APP_API_URL + 'cfe/relatorioFiscal'
        let params = "?token=" + localStorage.getItem("token") + "&" + "data_fim=" +this.data_fim+"&data_inicio="+this.data_inicio+"&cnpj="+loja.cnpj+"&razao_social="+ encodeURIComponent(loja.razao_social) +"&modelo="+this.modelo+"&status="+this.status+"&data_sinc="+this.data_sinc;

        this.notasHref = url + params
      },
      getLastMonth(){
        this.data_fim_cabecalho =  moment().subtract(1,'months').endOf('month').format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment().subtract(1,'months').startOf('month').format('DD/MM/YYYY');
        this.data_fim =  moment().subtract(1,'months').endOf('month').format('YYYY-MM-DD');
        this.data_inicio = moment().subtract(1,'months').startOf('month').format('YYYY-MM-DD');
        this.loadNotas()
        this.loadSum()
      },
      getCurrentMonth(){
        this.data_fim_cabecalho =  moment().endOf('day').format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment().startOf('month').format('DD/MM/YYYY');
        this.data_fim =  moment().endOf('day').format('YYYY-MM-DD');
        this.data_inicio = moment().startOf('month').format('YYYY-MM-DD');
        this.loadNotas()
        this.loadSum()

      }
    },
    mounted() {
      this.token = localStorage.getItem('token');
      this.loadNotas()
      this.loadSum()
    }
}
</script>

<style type="text/css">
.check-color{
  color: #58b458;
  font-size: 40px;
  padding-top: 10px;
}
.mc-footer{
  background-color: #58b458;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.material-card{
  margin-bottom: 25px;
  border:1px solid #ccc;
  border-radius: 5px;
}
.card-content{
  text-align: center;
  padding-bottom: 5px;
  color: #6c757d;
}

.times-color{
  color: red;
  font-size: 40px;
  padding-top: 10px;

}
.mc-footer-canc{
  background-color: red;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.ban-color{
  color:#6c757d;
  font-size: 40px;
  padding-top: 10px;
}
.mc-footer-ban{
  background-color: #6c757d;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
.clock-color{
  color:#ffc107;
  font-size: 40px;
  padding-top: 10px;
}
.mc-footer-clock{
  background-color: #ffc107;
  color: whitesmoke;
  padding: 5px;
  text-align: center;
}
</style>